import React from 'react'
import { loadScript, unixTimestamp, useEffectAfter } from 'app/utils'
import { useSelector } from 'react-redux'
import { RootState } from 'app/session/store'

declare var GelSDK: any

export type GELWidgetProps = {
  isOpen: boolean
  SDKParams: GELSDKProps
  pickupPointSelected?: (response: GELSDKResponse) => void
  pickupPointError?: () => void
}

export type GELSDKProps = {
  urlEndUser?: string
  apiKey?: string | null
  merchantCode?: string | null
  reference?: string | null
  redirectMode?: 'GET' | 'POST'
  urlRedirectOk?: string
  urlRedirectCancel?: string
  locale?: string
  isReturnOrder?: boolean
  width?: number | null
  height?: number | null
  depth?: number | null
  createUIModal?: (param: { callbackOk: (response: any) => void, callbackKo: () => void }) => void
}

export type GELSDKResponse = {
  address: string
  city: string
  code: string
  cost: number
  costInsurance: number
  costPickupPoint: number
  country: string
  currencyCost: string
  department: string
  description: string
  insuranceAccepted: boolean
  insuranceEnabled: boolean
  insurancePaidByMerchant: boolean
  isReturnOrder: boolean
  lat: number
  long: number
  pickupPointId: number
  reference: string
  shouldUseGELProximityPrices: boolean
  zipCode: boolean
}

const GELWidget = ({ ...props }: GELWidgetProps) => {
  const session = useSelector((state: RootState) => state.session)
  const [GEL, setGEL] = React.useState<GELSDKProps | null>(null)
  const [GELIsInitialized, setGELIsInitialized] = React.useState<boolean>(false)

  React.useEffect(() => {
    loadScript(session.config?.service.GELSDK.scriptUrl)
      .then(() => {
        setGELIsInitialized(true)
        if (GEL == null) buildSDK()
      })
      .catch((error: any) => { console.error(error) })
  }, [])

  function buildSDK() {
    const params: GELSDKProps = {
      ...props.SDKParams,
      redirectMode: props.SDKParams.redirectMode ?? 'POST',
      reference: props.SDKParams.reference ?? 'orderReference-' + String(unixTimestamp()),
    }

    setGEL(new GelSDK(params))
  }

  useEffectAfter(() => {
    if (GELIsInitialized === false) return
    if (props.SDKParams.reference == null) return
    if (props.SDKParams.width == null) return
    if (props.SDKParams.height == null) return
    if (props.SDKParams.depth == null) return
    buildSDK()
  }, [GELIsInitialized, props.SDKParams.reference, props.SDKParams.width, props.SDKParams.height, props.SDKParams.depth])

  React.useEffect(() => {
    if (props.isOpen === true) showMap()
  }, [props.isOpen])

  React.useEffect(() => {
  }, [GEL])

  function showMap() {
    if (GEL == null) return
    GEL.createUIModal!({
      callbackOk: (response: any) => {
        if (props.pickupPointSelected != null) props.pickupPointSelected(response)
      },
      callbackKo: () => {
        if (props.pickupPointError != null) props.pickupPointError()
      }
    })
  }

  return (<></>)
}

export default GELWidget